import React, { useEffect, useState } from "react";
import { LuWallet2 } from "react-icons/lu";
import { GoBell } from "react-icons/go";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useClientType } from "../../../ContextApi/ClientTypeContext";
import {
  GetAgencyDashboard,
  GetDashboard,
  GetNotification,
} from "../../../redux/actions/client/dashboard";
import { getFormattedDate } from "../../../helpers/utils";
import { useTranslation } from "react-i18next";
import { lngs } from "../../../i18n/i18n";
import { BsChevronDown } from "react-icons/bs";
import api from "../../../services/client/api";
import {
  clearLocalStorage,
  clearSessionStorageAll,
} from "../../../helpers/apihelper";
import { toast } from "react-toastify";
import noImage from '../../../assets/images/no_profile.jpg'

const TopBar = ({ title, ...args }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { clientType } = useClientType();
  const dispatch = useDispatch();

  const [selectedLang, setSelectedLang] = useState(
    JSON.parse(localStorage.getItem("lang")) || {
      code: "en",
      native: "English",
      flag: "🇬🇧",
    }
  );
  // const [isNotification, setIsNotification] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notification, setnotification] = useState({ system: [], wallet: [] });
  const handleLogout = () => {
    try {
      setLoading(true);
      if(clientType === 'agency') {
        api.logOutAgency({ deviceToken: localStorage.getItem("fcmToken") })
        .then((res) => {
          setLoading(false);
          if (res.data.status) {
            toast.success(res.data.message);
            navigate("/client/signin", { replace: true });
            clearSessionStorageAll();
            clearLocalStorage("persist:root");
          }
        }).catch((err) => {
          toast.error(err)
          console.log(err)
        })
      }else {

        api.logOut({ deviceToken: localStorage.getItem("fcmToken") })
          .then((res) => {
            setLoading(false);
            if (res.data.status) {
              toast.success(res.data.message);
              navigate("/client/signin", { replace: true });
              clearSessionStorageAll();
              clearLocalStorage("persist:root");
            }
          }).catch((err) => {
            toast.error(err)
            console.log(err)
          })
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleChange = (lang) => {
    setSelectedLang(lang);
    i18n.changeLanguage(lang.code);
    localStorage.setItem("lang", JSON.stringify(lang));
    setIsOpen(false);
  };

  const loadLanguage = () => {
    const savedLang = selectedLang || {
      code: "en",
      native: "English",
      flag: "🇬🇧",
    };
    i18n.changeLanguage(savedLang.code);
  };

  useEffect(() => {
    if (clientType !== "agency") {
      dispatch(GetDashboard("past-12"));
    } else {
      dispatch(GetAgencyDashboard("past-12"));
    }
    dispatch(GetNotification(clientType));
    loadLanguage();
  }, []);
  const [walletLoader, setWalletLoader] = useState(false);

  const handleWallet = () => {
    try {
      setWalletLoader(true);
      dispatch(GetNotification(clientType, "WALLET")).then((res) => {
        setWalletLoader(false);
        setnotification((prev) => ({
          ...prev, // Keeps other notifications intact
          wallet: res.rows,
        }));
      });
    } catch (e) {
      setWalletLoader(false);
    }
  };
  const [notificationLoader, setNotificationLoader] = useState(false);
  const handleNotification = () => {
    try {
      setNotificationLoader(true);
      dispatch(GetNotification(clientType, "SYSTEM")).then((res) => {
        setNotificationLoader(false);
        setnotification((prev) => ({ ...prev, system: res.rows }));
      });
    } catch (e) {
      setNotificationLoader(false);
      console.log(e);
    }
  };

  const data = useSelector((state) => state?.dashboard?.dashboard?.data?.user);

  const { t } = useTranslation();
  return (
    <div className="topbar d-flex justify-content-between align-items-center flex-wrap pt-4 mb-4">
      <p className="left mb-3 mb-sm-0 mr-2 mr-md-0">{title}</p>
      <div className="right d-flex justify-content-sm-end align-items-center flex-wrap">
        <div className="relative inline-block text-left mx-0 mx-md-3 mr-3 mr-sm-0">
          {/* Dropdown Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center px-4 py-2 border rounded-lg shadow-md bg-white hover:bg-gray-100"
          >
            <span className="mr-2">{selectedLang.flag}</span>
            <span>{selectedLang.native}</span>
            <BsChevronDown className="ml-2 w-4 h-4" />
          </button>

          {/* Dropdown Menu */}
          {isOpen && (
            <ul className="position-absolute custom_dropdown mt-2 w-44 bg-white border rounded-lg shadow-lg p-0 z-50">
              {lngs.map((lang,i) => (
                <li
                  key={i}
                  className="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-left list-style-none"
                  onClick={() => handleChange(lang)}
                >
                  <span className="mr-2">{lang.flag}</span>
                  <span>{lang.native}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="wallet">
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav onClick={handleWallet}>
                <LuWallet2 />
              </DropdownToggle>
              <DropdownMenu
                className="dropdown-menu-arrow"
                style={{ height: "400px", width: "275px", overflow: "auto" }}
                end
              >
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Wallet</h6>
                </DropdownItem>
                {notification?.wallet && notification?.wallet?.length > 0 ? (
                  notification?.wallet?.map((items) => {
                    if (items.isDeleted === "0") {
                      return (
                        <div key={items.id}>
                          <DropdownItem>
                            <div className="d-flex align-items-center">
                              <div className="text-wrap">
                                <h3 className="m-0 text-primary">
                                  {items?.title}
                                </h3>
                                <small className="mb-0">{items?.message}</small>
                                <small className="text-muted">
                                  {getFormattedDate(items?.updatedAt)}
                                </small>
                              </div>
                            </div>
                          </DropdownItem>
                          <DropdownItem divider />
                        </div>
                      );
                    }
                    return null; // Return null if conditions aren't met.
                  })
                ) : (
                  <h3 className="text-center text-primary">
                    <>
                      {walletLoader ? (
                        <Spinner> </Spinner>
                      ) : (
                        "No Transaction Record!"
                      )}
                    </>
                  </h3>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </div>
        <div className={` notified ml-3 `}>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav onClick={handleNotification}>
                <GoBell />
              </DropdownToggle>
              <DropdownMenu
                className="dropdown-menu-arrow"
                style={{ height: "400px", width: "275px", overflow: "auto" }}
                end
              >
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Notifications</h6>
                </DropdownItem>
                {notification?.system && notification?.system?.length > 0 ? (
                  notification?.system?.map((items) => {
                    if (items.isDeleted === "0") {
                      return (
                        <div  key={items.id}>
                          <DropdownItem
                           
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <div className="text-wrap">
                                <div className="d-flex justify-content-between">
                                  <h3 className="m-0 text-primary">
                                    {items?.title}
                                  </h3>
                                  {/* <LuView /> */}
                                </div>
                                <small className="mb-0">{items?.message}</small>
                                <small className="text-muted">
                                  recived on{" "}
                                  {getFormattedDate(items?.updatedAt)}
                                </small>
                              </div>
                            </div>
                          </DropdownItem>
                          <DropdownItem divider />
                        </div>
                      );
                    }
                    return null; // Return null if conditions aren't met.
                  })
                ) : (
                  <h3 className="text-center text-primary">
                    {notificationLoader ? (
                      <Spinner>{""}</Spinner>
                    ) : (
                      "No Transaction Record!"
                    )}
                  </h3>
                )}

                {/* <DropdownItem className="text-center text-primary" onClick={() => navigate("/notifications")}>
                  View All Notifications
                </DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </div>

        <div className="user d-flex align-items-center">
          <Dropdown
            direction="down"
            style={{ boxShadow: "none" }}
            isOpen={dropdownOpen}
            toggle={toggle}
          >
            <DropdownToggle
              style={{
                boxShadow: "none",
                border: "none",
                background: "transparent",
              }}
              className="d-flex align-items-center pl-0 pl-sm-2 my-2 my-sm-0"
              caret
            >
              {loading ? (
                <Spinner>{""}</Spinner>
              ) : (
                <div className="user-pic ">
                  <img src={data?.profileImage ?? noImage} alt="profileImage" />
                </div>
              )}{" "}
              <p className="mb-0 pl-2">
                {data?.firstName === undefined
                  ? data?.name
                  : data?.firstName}{" "}
              </p>
            </DropdownToggle>
            <DropdownMenu {...args}>
              <DropdownItem
                onClick={() =>
                  navigate(
                    clientType === "agency"
                      ? "/agency/profile"
                      : "/client/profile"
                  )
                }
              >
                {t("profile")}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={handleLogout}> {t("logout")}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
